import React, { useState } from 'react';

function DepartmentCard({
  loading,
  saving,
  departments = [],
  selectedDeptId,
  onSelect,
  newDeptName,
  setNewDeptName,
  onAddDepartment,
  onUpdateDepartment,
  onToggleDepartmentStatus,
}) {
  const [editId, setEditId] = useState(null);
  const [editName, setEditName] = useState('');

  return (
    <div className="card shadow p-3">
      <div className="d-flex align-items-center justify-content-between mb-2">
        <h5 className="mb-0">Departments</h5>
        {saving && <span className="badge bg-warning text-dark">Saving…</span>}
      </div>

      {loading ? (
        <div className="text-muted py-4 text-center">⏳ Loading…</div>
      ) : departments.length === 0 ? (
        <div className="text-muted text-center py-3">🚫 No departments found</div>
      ) : (
        <ul className="list-group mb-3">
          {departments.map((dept) => {
            const active = selectedDeptId === dept.id;
            return (
              <li
                key={dept.id}
                className={`list-group-item d-flex justify-content-between align-items-center ${
                  active ? 'active text-white' : ''
                }`}
                style={{ cursor: 'pointer' }}
                onClick={() => onSelect(dept)}
              >
                {editId === dept.id ? (
                  <div className="w-100 d-flex gap-2 align-items-center">
                    <input
                      className="form-control"
                      value={editName}
                      onClick={(e) => e.stopPropagation()}
                      onChange={(e) => setEditName(e.target.value)}
                    />
                    <button
                      className="btn btn-sm btn-success"
                      onClick={(e) => {
                        e.stopPropagation();
                        const name = editName.trim();
                        if (!name) return;
                        onUpdateDepartment(dept.id, name);
                        setEditId(null);
                      }}
                    >
                      💾
                    </button>
                    <button
                      className="btn btn-sm btn-secondary"
                      onClick={(e) => {
                        e.stopPropagation();
                        setEditId(null);
                      }}
                    >
                      ✖
                    </button>
                  </div>
                ) : (
                  <>
                    <div className="d-flex align-items-center gap-2">
                      <span>{dept.name}</span>
                      <span
                        className={`badge ${
                          dept.status === 1 ? 'bg-success' : 'bg-secondary'
                        }`}
                      >
                        {dept.status === 1 ? 'Active' : 'Inactive'}
                      </span>
                    </div>

                    <div className="d-flex align-items-center gap-2">
                      <button
                        className={`btn btn-sm ${
                          dept.status === 1 ? 'btn-outline-light' : 'btn-outline-light'
                        }`}
                        onClick={(e) => {
                          e.stopPropagation();
                          onToggleDepartmentStatus(dept.id, dept.status === 1 ? 0 : 1);
                        }}
                        title="Toggle Status"
                      >
                        {dept.status === 1 ? '🟢' : '⚫'}
                      </button>

                      <button
                        className="btn btn-sm btn-warning"
                        onClick={(e) => {
                          e.stopPropagation();
                          setEditId(dept.id);
                          setEditName(dept.name);
                        }}
                        title="Rename"
                      >
                        ✏️
                      </button>
                    </div>
                  </>
                )}
              </li>
            );
          })}
        </ul>
      )}

      <div className="d-flex gap-2">
        <input
          type="text"
          className="form-control"
          placeholder="New department"
          value={newDeptName}
          onChange={(e) => setNewDeptName(e.target.value)}
        />
        <button className="btn btn-primary" onClick={onAddDepartment} disabled={saving}>
          ➕ Add
        </button>
      </div>
    </div>
  );
}

export default DepartmentCard;
